export default "__VITE_ASSET__rfjGUa4j__"